"use strict";
exports.__esModule = true;
exports.userPermissions = exports.permissionInstances = exports.data = void 0;
exports.data = [
    {
        uuid: 'uuid1',
        name: 'app'
    },
    {
        uuid: 'uuid2',
        name: 'admin'
    }
];
exports.permissionInstances = [
    {
        uuid: 'uuid1',
        permission: { uuid: 'uuid1' },
        instance: { uuid: 'uuid1' }
    },
    {
        uuid: 'uuid2',
        permission: { uuid: 'uuid2' },
        instance: { uuid: 'uuid1' }
    }
];
exports.userPermissions = [
    {
        uuid: 'uuid1',
        name: 'App',
        PermissionInstance: [
            {
                uuid: 'uuid1'
            }
        ]
    }
];
